import { Col, Row, Layout } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import Indicator from 'common/components/indicator/Indicator';
import Messages from 'i18n/messages/eula';

const RenderLoading = ({ tip }) => {
  return (
    <Layout style={{ height: '100vh', background: 'white' }}>
      <Col span={24}>
        <Row
          justify='center'
          align='middle'
          style={{ height: '100%' }}
          className='critial-messages'
        >
          <Col xs={24} sm={18} md={16} lg={13}>
            <Indicator
              loading
              tip={tip || <FormattedMessage {...Messages.loadingTip} />}
              size='large'
            />
          </Col>
        </Row>
      </Col>
    </Layout>
  );
};

export default injectIntl(RenderLoading);
